import { combineReducers } from "redux";

import categoryUserSitePublisher from "./categoryUserSitePublisher";
import reportCampaign from "./reportCampaign";
import bannerGenerator from "./bannerGenerator";

export default combineReducers({
  categoryUserSitePublisher,
  reportCampaign,
  bannerGenerator,
});
